// When the user is on the /cart page, set the localStorage flag and redirect with ?cart=true
if (window.location.pathname === '/cart') {
    console.log('Setting redirected_from_cart flag');
    // Set the flag in localStorage before redirecting
    localStorage.setItem('redirected_from_cart', 'true');

    // Redirect to homepage with ?cart=true
    setTimeout(function () {
        console.log('Redirecting to homepage with ?cart=true...');
        window.location.href = '/?cart=true'; // Redirect to homepage with the query parameter
    }, 10); // 2 seconds delay
}

// On homepage ("/"), check if the user was redirected from /cart with ?cart=true in URL
else if (window.location.pathname === '/' && window.location.search.includes('cart=true')) {
    const wasRedirected = localStorage.getItem('redirected_from_cart');
    console.log('Redirected from cart:', wasRedirected);

    if (wasRedirected === 'true') {
        console.log('Triggering click on cart icon...');

        // Delay the click on the cart icon by 1 second
        setTimeout(function () {
            const cartIcon = document.querySelector('.dev_cart_icon_click');
            if (cartIcon) {
                cartIcon.click(); // Trigger the click on the cart icon
            }
        }, 1000); // 1 second delay

        // After the delay, remove the flag from localStorage
        localStorage.removeItem('redirected_from_cart');
    }
}